// extracted by mini-css-extract-plugin
export default {"settings":"SettingsPage_settings__EL7vG","divider":"SettingsPage_divider__yETBE"};